// extracted by mini-css-extract-plugin
export default {"content-root":"_2CUgA","contentRoot":"_2CUgA","title":"_1iAgj","message":"_2F-Uh","image":"bFVHD"};